import {getMask, isValid as isValidPhone, normalizePhone} from '@yandex-delivery/core/phones/selectors'
import {addQuery, window} from '@yandex-delivery/utils'

import type {AppConfig, ClientConfig, ServerConfig} from '../types'
import {__CONFIG_KEY__} from './consts'

const serverConfig: ServerConfig = window ? window[__CONFIG_KEY__] : {}
serverConfig.currencySign = '₽'
serverConfig.origin = window?.location.origin

function getPassportUrl(path: string): string {
  const url = new URL(path, serverConfig.passportHost)

  url.searchParams.append('retpath', window?.location.href)
  url.searchParams.append('lang', serverConfig.lang)
  serverConfig.passportAppID && url.searchParams.append('origin', serverConfig.passportAppID)

  return url.toString()
}

const {rules = [], localReplacements} = serverConfig
const clientConfig: ClientConfig = {
  getAccountUrl(paramsOrPath, params) {
    const path = typeof paramsOrPath === 'string' ? paramsOrPath : '/'
    const url = serverConfig.accountUrl + path

    if (typeof paramsOrPath === 'object') {
      params = paramsOrPath
    }

    return params ? addQuery(url, params) : url
  },
  getRegistrationUrl(params) {
    return params ? addQuery(serverConfig.registrationUrl, params) : serverConfig.registrationUrl
  },
  getPhoneMask(phone) {
    return getMask(rules, phone, '+x (xxx) xxx xx xx') // в КЗ и РУ такие маски, заменяю дефолтную
  },
  normalizePhone: normalizePhone(rules, localReplacements),
  checkIsValidPhone: isValidPhone(rules),
  getPassportUrl,
}

export const appConfig: AppConfig = Object.assign<ServerConfig, ClientConfig>(serverConfig, clientConfig)
